export default "__VITE_ASSET__C8EOjiaD__"